import PropTypes from 'prop-types';
import React from 'react';
import GenerateTSV from '../core/TSV/GenerateTSV.js';
import { makeCancelable, sortObjects } from '../core/utils/utils.js';
import GS from '../grafsync/grafsync.js';
import workerCode from '../vocabulary/workers/tsv-export.js';

class DatasetExportExamples extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            examples: undefined
        };
        this.cancellable = null;
    }

    componentDidMount() {
        this.getExamples();
    }

    getExamples = async () => {
        try {
            let search = [
                {
                    predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                    value: "https://grafsync.graphifi.com/schema/gs/Resource"
                },
                {
                    predicate: "https://grafsync.graphifi.com/schema/gs/inDataset",
                    value: this.props.id
                }
            ];
            const data = await this.doSearch({
                search,
                noCount: true,
                retainOrder: true,
                fast: true,
                graph: [this.props.graph],
                predicates: ["http://www.w3.org/2000/01/rdf-schema#label"],
                page: 1,
                language: this.props.defaultLang,
                pageSize: 3
            }).promise;
            if (this.cancellable && this.cancellable.isCancelled()) return;
            if (data.results && data.results.length > 0) {
                const secondLang = this.props.viewLang !== this.props.defaultLang ? this.props.defaultLang : null;
                const sortedResources = sortObjects(data.results, "label", this.props.viewLang, secondLang, false);
                const examples = sortedResources.map(result => result.id);
                this.setState({
                    examples,
                    isLoading: false
                });
            }
            else {
                this.setState({ isLoading: false });
            }
        }
        catch (e) {
            if (this.cancellable && this.cancellable.isCancelled()) return;
        }
    };

    doSearch(payload) {
        this.cancellable = makeCancelable(GS.search(payload));
        return this.cancellable;
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    render() {

        const { graph, ontologyProjectAssociation, defaultLang, entitlements } = this.props;
        const { examples } = this.state;

        return (
            <GenerateTSV
                ontologyProjectAssociation={ontologyProjectAssociation}
                tsvFunction={workerCode}
                tsvMode="dataset"
                entitlements={entitlements}
                examples={examples}
                graph={graph}
                options={{
                    labelProp: 'label',
                    columns: {
                        "https://grafsync.graphifi.com/schema/tsv/resources": "Resources",
                        "https://grafsync.graphifi.com/schema/tsv/IRI": "IRI"
                    },
                    datatypeProperties: {},
                    objectProperties: {
                        "type": {
                            "displayName": "Class",
                            "iri": "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
                        }
                    }
                }}
                defaultLang={defaultLang}
                resource={this.props.id}
                labelsExportName="datasetlist"
                exportName="datasetlist" />
        );
    }
}

DatasetExportExamples.propTypes = {
    entitlements: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    ontologyProjectAssociation: PropTypes.array
};

export default DatasetExportExamples;